import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import { Link, Navigate, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import {
  Typography,
  TextField,
  Button,
  MenuItem,
  Modal,
  Switch,
} from "@mui/material";
import { getUser, postEdituser, rolesList } from "../Service";
import Swal from "sweetalert2";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import Skeleton from "@mui/material/Skeleton";
import CircularProgress from "@mui/material/CircularProgress";
import LoadingButton from "@mui/lab/LoadingButton";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import { addLog } from "../../utils/addLog";
import { useTranslation } from "react-i18next";
import { signOut } from "../../utils/signOut";
import { departmentList } from "../../utils/departmentList";

const styleModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  height: 200,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 3,
};

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box
      sx={{
        flexShrink: 0,
        ml: 2.5,
      }}
    >
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default function EditUser() {
  const [t, i18n] = useTranslation("global");

  const [userData, setUserData] = React.useState(
    JSON.parse(sessionStorage.getItem("authUserData"))
  );
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [loadingdata, setLoadingData] = useState(true);
  const [loading, setLoading] = useState(true);

  const [role, setRole] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [firstName, setFirstName] = React.useState("");
  const [department, setDepartment] = React.useState("");
  const [dataRoles, setDataRoles] = React.useState([]);

  const [checked, setChecked] = React.useState(true);
  const [progress, setProgress] = React.useState(0);

  const [errTextFname, setErrTextFname] = React.useState("");
  const [errFname, setErrFname] = React.useState(false);
  const [errTextEmail, setErrTextEmail] = React.useState("");
  const [errEmail, setErrEmail] = React.useState(false);

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  const { id } = useParams();

  const [openModal, setOpenModal] = useState(false);
  const [loadingbutton, setloadingbutton] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleClickModal = () => {
    setloadingbutton(true);
    editUser();
    addLog("User", "Edit", null);
  };

  const listRoles = () => {
    let qString = "?";

    rolesList(qString).then((res) => {
      if (res && res.status === 200) {
        setDataRoles(res.data);
      } else if (res.status === 401) {
        signOut();
      }
    });
  };
  React.useEffect(() => {
    listRoles();
  }, []);

  ////////// for Progress loading //////////
  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          return 0;
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 500);

    return () => {
      clearInterval(timer);
    };
  }, []);

  ////////// for get DataUser //////////
  React.useEffect(() => {
    getDatauser();
  }, []);

  const handleChangeSwitch = (event) => {
    setChecked(event.target.checked);
  };

  //////////////// Get User by id ////////////////
  function getDatauser() {
    getUser(id).then((res) => {
      if (res && res.status === 200) {
        setData(res.data);
        setFirstName(res.data.name);
        setEmail(res.data.email);
        setDepartment(res.data.department);
        setRole(res.data.role_id);

        if (res.data.isActive === 1) {
          setChecked(true);
        } else {
          setChecked(false);
        }
      } else if (res.status === 401) {
        signOut();
      }
      setLoadingData(false);
    });
  }

  //////////////// Edit User ////////////////

  const editUser = () => {
    const dataForm = {
      email: email,
      name: firstName,
      department: department,
      role: role,
      isActive: checked ? "1" : "0",
      updated_by: userData.userID,
    };

    postEdituser(dataForm, id).then((response) => {
      setloadingbutton(false);
      handleCloseModal();
      if (response && response.status === 200) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: t("user.success.update"),
          showConfirmButton: false,
        });
        navigate("/user");
      } else {
        console.log(
          "API response error1 [" + response.status + "]",
          response.data.err
        );
        Swal.fire({
          icon: "error",
          text: t("user.err.update"),
        });
        if (response.status === 409) {
          setErrTextEmail("email นี้มีในระบบแล้ว");
          setErrEmail(true);
        }
      }
    });
  };

  return (
    <Box
      style={{
        margin: "65px 0px 0px 0px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box style={{ display: "flex" }}>
        <div role="presentation">
          <Breadcrumbs aria-label="breadcrumb">
            <Link
              underline="hover"
              to={`/user`}
              style={{ textDecoration: "none", color: "#9e9e9e" }}
            >
              <Typography
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "400",
                }}
              >
                {t("user.header")}
              </Typography>
            </Link>

            <Typography
              style={{
                fontSize: "1.2rem",
                fontWeight: "400",
                color: "#212121",
              }}
            >
              {t("user.subtitle.edit")}
            </Typography>
          </Breadcrumbs>
        </div>
      </Box>

      {/*  ////////////////////////// Main Topic Pages ////////////////////////// */}
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          style={{
            display: "flex",
            marginTop: "25px",
            alignItems: "center",
          }}
        >
          <ManageAccountsIcon fontSize="large" sx={{ mr: "5px" }} />
          <Typography
            style={{
              fontWeight: "400",
              color: "#1565c0",
              fontSize: "1.5rem",
            }}
          >
            {t("user.subtitle.edit")}
          </Typography>
        </Box>

        {loadingdata ? (
          <Box>
            <Box>
              <Box>
                <Box sx={{ mt: 3, display: "flex" }}>
                  <Box>
                    <Skeleton variant="rounded" width={400} height={45} />
                  </Box>
                </Box>
                <Box sx={{ mt: 3, display: "flex" }}>
                  <Box sx={{ mr: 4 }}>
                    <Skeleton variant="rounded" width={400} height={45} />
                  </Box>
                </Box>

                <Box sx={{ mt: 3, display: "flex" }}>
                  <Box sx={{ mr: 4 }}>
                    <Skeleton variant="rounded" width={400} height={45} />
                  </Box>
                </Box>
              </Box>

              <Box
                sx={{
                  mt: 3,
                  width: 400,
                }}
              >
                <Box>
                  <Skeleton
                    variant="text"
                    sx={{ fontSize: "16px" }}
                    width={150}
                  />
                  <Skeleton
                    variant="text"
                    sx={{ fontSize: "12px" }}
                    width={200}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        ) : (
          <Box>
            <Box>
              <Box sx={{ mt: 3, display: "flex" }}>
                <Box sx={{ width: 400, mr: 4 }}>
                  <TextField
                    label={t("user.txtbox.user.name")}
                    variant="outlined"
                    size="middle"
                    fullWidth
                    value={firstName}
                    error={errFname}
                    onChange={(e) => {
                      setFirstName(e.target.value);
                      if (e.target.value) {
                        setErrTextFname("");
                        setErrFname(false);
                      } else {
                        setErrTextFname("กรุณากรอกชื่อ*");
                        setErrFname(true);
                      }
                    }}
                    helperText={errTextFname}
                  />
                </Box>
              </Box>
              <Box sx={{ mt: 3, display: "flex" }}>
                <Box sx={{ width: 400, mr: 4 }}>
                  <TextField
                    label={t("user.txtbox.user.email")}
                    variant="outlined"
                    size="middle"
                    fullWidth
                    placeholder="กรอก email ในรูปแบบ test@example.com"
                    value={email}
                    error={errEmail}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      if (!isValidEmail(e.target.value)) {
                        setErrTextEmail("กรุณากรอก email*");
                        setErrEmail(true);
                      } else {
                        setErrTextEmail(null);
                        setErrEmail(false);
                      }
                    }}
                    helperText={errTextEmail}
                  />
                </Box>
              </Box>

              <Box sx={{ mt: 3, display: "flex" }}>
                <Box sx={{ width: 400, mr: 4 }}>
                  <TextField
                    size="middle"
                    fullWidth
                    select
                    label={t("user.txtbox.user.department")}
                    value={department}
                    onChange={(e) => {
                      setDepartment(e.target.value);
                      setRole("");
                    }}
                  >
                    {departmentList.map((option) => (
                      <MenuItem key={option.id} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Box>
              </Box>

              <Box sx={{ mt: 3, display: "flex" }}>
                <Box sx={{ width: 400, mr: 4 }}>
                  <TextField
                    size="middle"
                    fullWidth
                    select
                    label={t("user.txtbox.user.role")}
                    value={role}
                    onChange={(e) => {
                      setRole(e.target.value);
                    }}
                  >
                    {dataRoles
                      .filter((row) => row.description.includes(department))
                      .map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.description}
                        </MenuItem>
                      ))}
                  </TextField>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                mt: 3,
                width: 400,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <Typography style={{ fontSize: "16px" }}>
                  {t("user.txtbox.user.status")}
                </Typography>
                <Typography style={{ fontSize: "12px", color: "#9e9e9e" }}>
                  {checked
                    ? t("user.txtbox.user.slide_active")
                    : t("user.txtbox.user.slide_inactive")}
                </Typography>
              </Box>
              <Box>
                <Switch
                  checked={checked}
                  onChange={handleChangeSwitch}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Box>
            </Box>
          </Box>
        )}
      </Box>
      <Box
        sx={{
          mt: 7,
          width: 400,
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <Button
            variant="contained"
            size="middle"
            style={{ backgroundColor: "#32B917", marginRight: "15px" }}
            onClick={() => {
              if (firstName.length === 0) {
                setErrFname(true);
                setErrTextFname("กรุณากรอกชื่อ*");
              }
              if (email.length === 0) {
                setErrEmail(true);
                setErrTextEmail("กรุณากรอก email*");
              }
              if (firstName.length > 0 && errEmail === false) {
                handleOpenModal();
              }
            }}
          >
            <Typography fontSize={14}>{t("user.button.edit")}</Typography>
          </Button>
          <Link
            underline="hover"
            to={`/user`}
            style={{ textDecoration: "none" }}
          >
            <Button variant="contained" size="middle" color="inherit">
              <Typography fontSize={14} style={{ color: "#212121" }}>
                {t("common.button.cancel")}
              </Typography>
            </Button>
          </Link>
        </Box>
        <Box>
          {!loading ? (
            <Box sx={{ width: "100%" }}>
              <CircularProgress disableShrink />
            </Box>
          ) : (
            ""
          )}
        </Box>
      </Box>

      <Modal open={openModal}>
        <Box sx={styleModal}>
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography marginTop={1} variant="h5" component="h2">
              {/* Edit User */}
              {t("user.popup.edit.header")}
            </Typography>
            <IconButton size="large" onClick={handleCloseModal}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Box>
          <Typography
            sx={{ mt: 3, color: "#616161" }}
            fontSize={14}
            fontWeight={300}
          >
            {t("user.popup.edit.txt1")}
          </Typography>
          <Box
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "5rem",
            }}
          >
            <LoadingButton
              color="primary"
              onClick={handleClickModal}
              loading={loadingbutton}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              size="large"
            >
              {t("common.button.update")}
            </LoadingButton>
            <Button
              style={{ marginLeft: 12 }}
              variant="outlined"
              size="middle"
              color="inherit"
              onClick={handleCloseModal}
            >
              <Typography fontSize={14}>{t("common.button.cancel")}</Typography>
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
